<template>
    <div class="purl_main">
        <div class="purl_tabs_d">
            <div v-if="tabActive==0">
                <van-tabs @click="onClickTitleSelected" animated color="#07affa" swipeable
                          title-active-color="#07affa" v-model="topActive">
                    <van-tab :key="titleIndex" :title="iTitle" v-for="(iTitle,titleIndex) in titleOArr"></van-tab>
                </van-tabs>
            </div>
            <div v-else-if="tabActive==1">
                <van-tabs @click="onClickTitleSelected" animated color="#07affa" swipeable
                          title-active-color="#07affa" v-model="topActive">
                    <van-tab :key="titleIndex" :title="iTitle" v-for="(iTitle,titleIndex) in titleTArr"></van-tab>
                </van-tabs>
            </div>
        </div>
        <div class="purl_main_middle">
            <van-list :finished="finished" @load="getData"
                      finished-text="没有更多了"
                      v-if="!indicatorType"
                      v-model="loading">
                <ul class="purl_cells_ul">
                    <li :key="cellIndex" v-for="(purDict,cellIndex) in listArr" v-on:click="jump(1, purDict)">
                        <div class="purl_top_d">
                            <div class="purl_top_d_title">{{purDict['realName']+' 在 '+purDict['providerName']+' 下单 '}}
                            </div>
                            <div class="purl_top_d_tr" v-if="tabActive==0">
                                <div class="purl_top_d_statue" v-if="purDict['orderMainVO']">
                                    {{statusObj[purDict['orderMainVO']['orderStatus']]}}
                                </div>
                                <div class="purl_top_d_statue" v-else>
                                    {{statusPObj[purDict['purchaseStatus']]}}
                                </div>
                                <div class="purl_top_d_pay" v-if="purDict['orderMainVO']">
                                    {{'[ '+payStatusObj[purDict['orderMainVO']['orderSettlementStatus']]+' ]'}}
                                </div>
                            </div>
                            <div class="purl_top_d_tr" v-else-if="tabActive==1">
                                <div class="purl_top_d_statue" v-if="topActive==0">需我审核</div>
                                <div class="purl_top_d_statue"
                                     v-else-if="(topActive==1 || topActive==2)&&(purDict['purchaseStatus']==3 || purDict['purchaseStatus']==4)">
                                    {{statusTPObj[purDict['purchaseStatus']]}}
                                </div>
                            </div>
                        </div>
                        <div :key="itemIndex" class="purl_middle_d"
                             v-for="(itemDict,itemIndex) in purDict['companyPurchaseItemVOList']">
                            <div class="purl_middle_img_d"><img :src="itemDict['skuImageUrl']" alt=""
                                                                class="purl_middle_d_img">
                            </div>
                            <div class="purl_middle_d_top">
                                <span class="purl_middle_d_top_name">{{itemDict['itemName']}}</span>
                                <span class="purl_middle_d_top_price">{{'¥ ' + itemDict['purchasePrice']*0.01}}</span>
                            </div>
                            <div class="purl_middle_d_bottom">
                                {{itemDict['propertiesName']+' x'+itemDict['purchaseNum']+itemDict['unitName']}}
                            </div>
                        </div>
                        <div v-if="tabActive==0">
                            <div class="purl_bottom_d"
                                 v-if="purDict['purchaseStatus']==1 || (purDict['purchaseStatus']==3 && (purDict['orderMainVO']['orderSettlementStatus']==1 || purDict['orderMainVO']['orderSettlementStatus']==2 || purDict['orderMainVO']['orderSettlementStatus']==4))">
                                <div class="purl_bottom_d_price">{{'合计:￥'+purDict['summary']*0.01}}</div>
                                <div class="purl_bottom_d_btn" v-if="purDict['purchaseStatus']==1">
                                    <button type="button">撤回订单</button>
                                </div>
                                <div class="purl_bottom_d_btn"
                                     v-else>
                                    <button type="button">添加收款</button>
                                </div>
                            </div>
                            <div class="purl_bottom_dd"
                                 v-else>
                                <div class="purl_bottom_d_price">{{'合计:￥'+purDict['summary']*0.01}}</div>
                            </div>
                        </div>
                        <div v-else-if="tabActive==1">
                            <div class="purl_bottom_dd">
                                <div class="purl_bottom_d_price">{{'合计:￥'+purDict['summary']*0.01}}</div>
                            </div>
                        </div>
                        <div class="purl_footer_d"></div>
                    </li>
                </ul>
            </van-list>
        </div>
        <div class="purl_main_footer">
            <van-tabbar v-model="tabActive">
                <van-tabbar-item :key="tabIndex" @click="tab"
                                 v-for="(tabItem,tabIndex) in tabBars">
                    <span :class="tabActive == tabIndex ? tabActive:''">{{tabItem.title}}</span>
                    <img
                        :src="props.active ? tabItem.active : tabItem.normal"
                        alt=""
                        slot="icon"
                        slot-scope="props"
                    >
                </van-tabbar-item>
            </van-tabbar>
        </div>
    </div>
</template>

<script>
    import head from '../../mixins/head';

    export default {
        mixins: [head],
        data() {
            return {
                titleOArr: ['全部', '待提交', '待审核', '审核中', '待收货', '已完成', '被驳回'],
                titleTArr: ['需我审核', '抄送给我', '审批历史'],
                listArr: [],
                itemArr: [],
                stateOArr: ['', '0', '1', '2', '-3', '-4', '9', '4'],
                stateTArr: ['2', '3', '4'],
                topActive: 0,
                animated: true,
                swipeable: true,
                page: 1,
                total: 0,
                pageSize: 10,
                statusObj: {
                    '0': '已作废',
                    '1': '未提交',
                    '2': '待审核',
                    '3': '审核中',
                    '4': '待付款',
                    '5': '待财务审核',
                    '6': '待出库',
                    '7': '待发货',
                    '8': '已发货',
                    '9': '已完成',
                    '10': '部分完成',
                    '11': '部分出库'
                },
                statusPObj: {
                    '0': '待提交', '1': '待审核', '2': '审核中', '3': '已同意', '4': '未通过'
                },
                statusTPObj: {
                    '3': '已同意', '4': '已作废'
                },
                payStatusObj: {
                    '1': '未支付',
                    '2': '部分支付',
                    '3': '支付完成',
                    '4': '待财务审核'
                },
                statusColorArr: ['E2AC51', 'a4afbc', '07affa', '63c993', 'fe7884', 'E2AC51', 'ff9e00', '07affa', '5a8cfc', '63c993', '40cbff', '40cbff'],
                statusPColorArr: ['07affa', 'fe7884', 'fe7884', 'a4afbc', 'a4afbc'],
                tabBars: [
                    {
                        name: 'purChase',
                        title: '我的采购',
                        normal: require('../../assets/img/purchase/PR_pur@3x.png'),
                        active: require('../../assets/img/purchase/PR_pur_selected@3x.png')
                    },
                    {
                        name: 'check',
                        title: '需我审核',
                        normal: require('../../assets/img/purchase/PR_ck@3x.png'),
                        active: require('../../assets/img/purchase/PR_ck_selected@3x.png')
                    },
                    {
                        name: 'ruKu',
                        title: '等待入库',
                        normal: require('../../assets/img/purchase/PR_rk@3x.png'),
                        active: require('../../assets/img/purchase/PR_rk_selected@3x.png')
                    }
                ],
                tabActive: 0,
                loading: false,
                finished: true,
                indicatorType: 0,
                listType: '',
                indicatorMessage: ''
            };
        },
        created() {
            this.getData();
        },
        methods: {
            onClickTitleSelected() {
                this.page = 1;
                this.getData();
            },
            tab() {
                this.topActive = 0;
                this.page = 1;
                this.getData();
            },
            //获取列表数据
            getData() {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {};
                let url = '';
                if (this.tabActive == '0') { //我的采购
                    url = 'purchase/companyPurchase/list.do';
                    param = {
                        page: this.page,
                        pagesize: this.pageSize,
                        purchaseStatus: this.stateOArr[this.topActive]
                    };
                } else if (this.tabActive == '1') { //需我审核
                    url = '/purchase/companyPurchase/queryApprovePurchase.do';
                    param = {
                        page: this.page,
                        pagesize: this.pageSize,
                        type: this.stateTArr[this.topActive]
                    };
                } else if (this.tabActive == '2') { //等待入库
                    url = '/purchase/companyPurchaseWaitStorehouse/list.do';
                    param = {
                        page: this.page,
                        pagesize: this.pageSize
                    };
                } else {
                    return;
                }
                this.$http.post(url, param, { toast: true })
                    .then((response) => {
                        this.$toast.clear();
                        this.data = response.data;
                        this.initData(response.data);
                    })
                    .catch((error) => {
                        console.log(error);
                        this.indicatorType = error.rspCode == -100 && (error.status != 403 || error.status != 500) ? 1 : 3;
                        this.indicatorMessage = error.rspMsg;
                        this.loading = false;
                        this.finished = true;
                    });
            },
            initData(purData) {
                if (this.page == 1) {
                    this.listArr.splice(0, this.listArr.length);
                }
                this.total = purData['pagination']['total'];
                this.page++;
                for (let i = 0; i < purData.result.length; i++) {
                    let item = purData.result[i];
                    this.listArr.push(item);
                }
                if (this.listArr.length >= this.total) {
                    this.finished = true;
                } else {
                    this.finished = false;
                }
                this.loading = false;
                if (this.listArr && this.listArr.length > 0) {
                    this.indicatorType = 0;
                } else {
                    this.indicatorType = 2;
                    this.indicatorMessage = '暂无任何采购订单哦';
                }
            },
            jump(cellIndex, purItem) {
                if (cellIndex == 1) {
                    this.PUSH({ name: 'purchase-detail', query: { item: purItem.id } });
                }
            }
        }
    };
</script>

<style lang="scss" scoped
>
    @import '../../assets/scss/purchase/purchase-list.scss';

</style>

